<template>
  <div class="demo-page">
    <RewardFlow />
  </div>
</template>

<script>
import RewardFlow from '~/site/widgets/quenUnlockWidget/components/RewardFlow.vue'

export default {
  components: { RewardFlow },
  data() {
    return {}
  }
}
</script>

<style lang="less">
.demo-page {
  background-color: white;
  width: 100vw;
  min-height: 100vh;
}
</style>
